import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/Button';
import { Input } from '@/components/ui/Input';
import { Card, CardBody, CardHeader, CardTitle } from '@/components/ui/Card';
import { BrandFooter } from '@/components/BrandFooter';
import { useAuthStore } from '@/stores/authStore';
import { AppInfo } from '@/lib/config';

const appVersion = AppInfo.version;

export function LoginPage() {
  const navigate = useNavigate();
  const login = useAuthStore((s) => s.login);
  const loading = useAuthStore((s) => s.loading);
  const errorState = useAuthStore((s) => s.error);
  const [driverNumber, setDriverNumber] = useState('');
  const [password, setPassword] = useState('');
  const [submitError, setSubmitError] = useState<string | null>(null);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitError(null);
    try {
      await login(driverNumber, password);
      navigate('/main');
    } catch (err) {
      setSubmitError((err as Error)?.message ?? 'Login failed');
    }
  };

  return (
    <div className="mx-auto flex min-h-full max-w-md flex-col items-center justify-center p-4">
      <Card className="w-full">
        <CardHeader>
          <CardTitle>Driver sign in</CardTitle>
        </CardHeader>
        <form onSubmit={submit}>
          <CardBody>
            <Input
              label="Driver number"
              autoComplete="username"
              autoCapitalize="off"
              autoCorrect="off"
              required
              value={driverNumber}
              onChange={(e) => setDriverNumber(e.target.value)}
            />
            <Input
              label="Password"
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            {(submitError || errorState) && (
              <p className="text-sm text-brand-error">{submitError ?? errorState}</p>
            )}
            <Button
              type="submit"
              variant="delivery"
              fullWidth
              size="lg"
              disabled={loading || !driverNumber || !password}
            >
              {loading ? 'Signing in...' : 'Sign in'}
            </Button>
            <button
              type="button"
              className="text-xs text-brand-muted underline"
              onClick={() => navigate('/setup')}
            >
              Change connection settings
            </button>
          </CardBody>
        </form>
      </Card>

      <BrandFooter className="mt-6" />
      <span className="mt-2 text-xs italic text-brand-muted">Pro {appVersion}</span>
    </div>
  );
}
